import React from 'react';
import { css } from '@emotion/css';
import LanguageModel from '../../../../models/features/api/LanguageModel';
import LanguageCollectionAvatar from '../../../../components/general/LanguageCollectionAvatar';
import { getLanguageNameForLanguage, getRegionyNameForLanguage, getLanguageName, getFlagIconForLanguage } from '../../../../models/extensions/languages';
import _ from 'lodash';
import GroupedMultiSelector, { ItemGroup } from '../../../../components/forms/GroupedMultiSelector';
import { CheckType } from '../../../../components/forms/CheckIndicator';

interface LanguageMultiSelectorProps {
    languages: LanguageModel[]
    selectedLanguageIds: string[]
    onChange: (selectedLanguageIds: string[]) => void
    label?: string
    className?: string
    warningRender?: JSX.Element
}
interface LanguageMultiSelectorState {
    isExpanded: boolean
}

class LanguageMultiSelector extends React.Component<LanguageMultiSelectorProps, LanguageMultiSelectorState> {
    constructor(props) {
        super(props)
        this.state = {
            isExpanded: false,
        }
    }

    handleChange(selectedIds: string[]) {
        this.props.onChange(selectedIds);
    }

    getLanguageGroups(): ItemGroup<LanguageModel>[] {
        let dict = _.groupBy(this.props.languages, l => l.languageGroupCode)
        let groups: ItemGroup<LanguageModel>[] = Object.keys(dict).map(key => ({
            key: key,
            label: `${key.toUpperCase()} - ${getLanguageName(key)}`,
            subItems: dict[key].map(lang => ({
                data: lang,
                value: lang.id,
                icon: getFlagIconForLanguage(lang),
                label: getRegionyNameForLanguage(lang),
                groupKey: key,
                isSelected: this.props.selectedLanguageIds.some(id => id == lang.id)
            }))
        }));

        groups = _.sortBy(groups, group => group.key);
        if(this.props.warningRender){
            groups.unshift({
                key: "warning",
                label: `warning`,
                customRender: this.props.warningRender,
                subItems: []
            });
        }
  
        return groups;
    }

    render() {
        const selectedLangs = this.props.languages.filter(l => this.props.selectedLanguageIds.some(id => id == l.id));
        return (
            <GroupedMultiSelector label={this.props.label ?? "Languages:"}
                groupToggle={groupToggleStyle}
                groups={this.getLanguageGroups()}
                onChange={this.handleChange.bind(this)}
                selectedValues={this.props.selectedLanguageIds}
                withGroupSelection={true}
                restrictGroups={true}
                className={this.props.className}
                subItemCheckType={"check"}
                position={"bottom"}
                emptyText="You must add at least one language to your application first."
                innerSelectionRender={
                    () => <>
                        <LanguageCollectionAvatar languages={selectedLangs} limit={3} />
                        <p className={labelStyle}>{selectedLangs.length > 0 ? selectedLangs.map(l => `${getLanguageNameForLanguage(l)} (${getRegionyNameForLanguage(l)})`).join(', ') : 'Select a language'}</p>
                    </>
                } />
        )
    }
}

const groupToggleStyle = css`
    margin-left: auto;
    margin-right: 8px;
`

const labelStyle = css`
    padding: 0 8px;
`

export default LanguageMultiSelector;